import { APPOINTMENT_SLOT_GAP_IN_MINS } from '@constant/appointment';
import { disableLoader, enableLoader, showError, showSuccess, showWarning } from '@context/actions';
import { Box, ClickAwayListener } from '@material-ui/core';
import ConfirmationModal from '@module/confirmationModal';
import { getAppointmentByTenantIdAndGuestId, requestAppointmentReschedule, rescheduleAppointment } from '@storeData/appointment';
import { getStaffByTenantAndStoreId, getStaffSlot } from '@storeData/staff';
import { checkStaffWeekOff, formatTimeTo12Hr, formatToDateFormat, getDateObj, getDisabledDates, getServiceDuration, removeObjRef, resetDateTimeToNow, timeToMins } from '@util/utils';
import { forwardRef, Fragment, memo, useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from 'react-redux';

import {
  CloseIcon,
  FaCalendarAlt,
  IconFrame,
} from '@element/icons';
function BookedSlotRescheduleModal({ item, onClose, setAppointmentHistoryData }) {

    const modalRef = useRef(null);
    const dispatch = useDispatch();
    const [cookie, setCookie] = useCookies();
    const [userData, setUserCookie] = useState(cookie['user']);
    const appointmentItems = useSelector((state: any) => state.appointmentServices);
    const [selectedItem, setSelectedItem] = useState(item)
    const [error, setError] = useState({ id: '', text: '' });
    const [anchorEl, setAnchorEl] = useState(null);
    const storeData = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [availableExpertSlotData, setAvailableExpertSlotData] = useState([]);
    const [availableSlots, setAvailableSlots] = useState([])
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [isLoading, setIsLoading] = useState(false);
    const store = useSelector((state: any) => state);
    const appointmentConfig = configData?.storeConfig?.appointmentConfig;
    const [dateChangeConfirmationModal, setDateChangeConfirmationModal] = useState({
        secondaryButtonText: "",
        openModal: false,
        title: '',
        message: '',
        buttonText: '',
        handleClose: null
    })
    const languageData: any = store.languageKeywords
    const DatePickerInput = forwardRef((props: any, ref: any) => <button className={`date-picker-button ${error.id == 'date' ? "error" : ""}`}
        onClick={props.onClick} ref={ref}>
        {languageData["Appointment Date"] ? languageData["Appointment Date"] : "Appointment Date"}: {props.value ? `: ${props.value}` : <div className='guided-label'> {languageData["Click to select date"] ? languageData["Click to select date"] : "Click to select date"}</div>}
    </button>);

    useEffect(() => {
        let selectedItemCopy = selectedItem
        selectedItemCopy.date = item.item.appointmentDay
        const firstExpertId = item.item?.expertAppointments?.[0]?.expertId;
        // setSelectedItem(selectedItemCopy)
        if (item) {
            setSelectedItem(item)
            setIsLoading(true)
            getStaffByTenantAndStoreId(storeData.tenantId, storeData.storeId)
                .then((expertsList: any) => {
                    setIsLoading(false)
                    if (expertsList) {
                        if (expertsList.length != 0) {
                            setAvailableExpertSlotData(expertsList.filter((e: any) => e.active));
                            let availableStaff = expertsList.filter((s) => s.active);
                            const firstExpertId = item.item?.expertAppointments?.[0]?.expertId;
                            let itemStaff = availableStaff.find((s) => s.id == firstExpertId);
                            selectedItemCopy.staff = itemStaff;
                            if (Boolean(itemStaff)) onInputChange("staff", itemStaff)
                            // let experts = item.item.expertAppointments.map((item: any) => item.expertId);
                            // console.log(experts)
                            // if (experts) {
                            //     experts.map((expertId: any) => {
                            //         let alreadyAdded = availableStaff.length != 0 ? availableStaff.filter((s) => s.id == expertId) : [];
                            //         if (alreadyAdded.length == 0) {
                            //             let staffs = expertsList.filter((s) => s.active && s.id == expertId);
                            //             staffs.length != 0 && availableStaff.push(staffs[0])
                            //         }
                            //     })
                            // }
                            if (availableStaff.length != 0) setAvailableExpertSlotData(availableStaff);
                            else setAvailableExpertSlotData([]);
                        } else setAvailableExpertSlotData([]);
                    }
                })
                .catch((e) => {
                    setIsLoading(false)
                    dispatch(showError(e.error));
                })
        }
        setSelectedItem(selectedItemCopy)
    }, [])

    const onOutsideClick = (event: any) => {
        if (modalRef.current && !modalRef.current.contains(event.target) && !dateChangeConfirmationModal.openModal) {
            onClose();
        }
    }

    const onInputChange = (from, value) => {
        const selectedItemCopy = removeObjRef(selectedItem)
        selectedItemCopy.slot = null;
        if (from == 'date') {
            value = resetDateTimeToNow(value)
        }
        selectedItemCopy[from] = value;
        setSelectedItem(selectedItemCopy)
        setError({ id: '', text: '' });
        setAnchorEl(null)

        if (selectedItemCopy.staff?.id && selectedItemCopy.date) {
            setIsLoading(true)
            getStaffSlot(getDateObj(new Date(selectedItemCopy.date)).dateObj, selectedItemCopy.staff?.id, storeData?.storeId, storeData?.tenantId).then((res: any) => {
                setIsLoading(false)
                setAvailableSlots(res.data || []);
                selectedItemCopy.staff.slots = res.data;
                setSelectedItem(selectedItemCopy)
            }).catch((err) => {
                setAvailableSlots([])
                setIsLoading(false)
            })
        }
        if (from == 'date') {
            setDateChangeConfirmationModal({
                secondaryButtonText: "",
                openModal: false,
                title: '',
                message: '',
                buttonText: '',
                handleClose: null
            })
        }
    }

    const onDateChange = (updatedDate) => {
        if (Boolean(appointmentItems.length) && (getDateObj(new Date(appointmentItems[0].date)).dateObj !== getDateObj(new Date(updatedDate)).dateObj)) {
            setDateChangeConfirmationModal({
                openModal: true,
                secondaryButtonText: `${languageData["Change"] ? languageData["Change"] : "Change"}`,
                title: `${languageData["Date Change Confirmation"] ? languageData["Date Change Confirmation"] : "Date Change Confirmation"}`,
                message: `${languageData["If you change the date, then the previously added service date and slot get reset."] ? languageData["If you change the date, then the previously added service date and slot get reset."] : "If you change the date, then the previously added service date and slot get reset."}`,
                buttonText: `${languageData['Cancel'] ? languageData['Cancel'] : 'Cancel'}`,
                handleClose: (status) => status ? onInputChange('date', updatedDate) :
                    setDateChangeConfirmationModal({
                        openModal: false,
                        secondaryButtonText: "",
                        title: '',
                        message: '',
                        buttonText: '',
                        handleClose: null
                    })
            })
        } else {
            //for the first time setting date
            onInputChange('date', updatedDate);
        }
    }

    const onReschedule = () => {
        if (Boolean(!selectedItem.slot)) {
            dispatch(showWarning(`${languageData["Please Select Slot"] ? languageData["Please Select Slot"] : "Please Select Slot"}`))
            return;
        }
        onClose()
        dispatch(enableLoader())
        const rescheduleBody = {
            "appId": item.item.id,
            "updateAllRecurring": false,
            "date": selectedItem && selectedItem?.date?.includes("T") ? selectedItem.date.split("T")[0] : selectedItem.date,
            "time": selectedItem.slot,
            "staffId": selectedItem.staff?.id,
            "sendSms": true,
            "requestId": null,
            "source": "catalog"
        }
        const requestRescheduleBody = {
            "appId": item.item.id,
            "currDate": item.item.appointmentDay.split("T")[0],
            "requestedDate": selectedItem.date.includes("T") ? selectedItem.date.split("T")[0] : selectedItem.date,
            "currTime": item.item.appointmentTime,
            "requestedTime": selectedItem.slot,
            "source": "catalog",
            "status": "CONFIRMED",
            "createdOn": new Date()
        }
        if (appointmentConfig.showBookedSlot) {
            //send the confirmed request entry to keep track
            rescheduleAppointment(rescheduleBody)
                .then((response: any) => {
                    if (response) {
                        if (response.code == 200) {
                            requestAppointmentReschedule(requestRescheduleBody)
                                .then((response: any) => {
                                    if (response) {
                                        dispatch(disableLoader());
                                        dispatch(showSuccess(`${languageData["Appointment Rescheduled Successfully"] ? languageData["Appointment Rescheduled Successfully"] : "Appointment Rescheduled Successfully"}`))
                                        getAppointmentByTenantIdAndGuestId(userData?.id, userData?.tenantId)
                                            .then((appointment: any) => {
                                                if (appointment.length) {
                                                    appointment.sort(function (a: any, b: any) {
                                                        var dateA: any = new Date(a.appointmentDay).getTime();
                                                        var dateB: any = new Date(b.appointmentDay).getTime();
                                                        return dateA < dateB ? 1 : -1;
                                                    });
                                                    setAppointmentHistoryData(appointment);
                                                    dispatch(disableLoader());
                                                }
                                            })
                                            .catch((e) => {
                                                dispatch(disableLoader());
                                                dispatch(showError(e.error));
                                            })
                                    }
                                })
                                .catch((e) => {
                                    dispatch(disableLoader());
                                    dispatch(showError(e.error));
                                })
                        }
                    }
                }).catch((e) => {
                    dispatch(disableLoader());
                    dispatch(showError(e.error));
                })
        }
    }

    const renderStaffList = () => {
        let staffData = [...availableExpertSlotData];
        staffData = staffData.filter(staff => !checkStaffWeekOff(selectedItem.date, staff.weeklyOff));
        return <div className="staff-list-wrapper">
            <ClickAwayListener onClickAway={(e: any) => {
                setAnchorEl(null);
            }}>
                <Box>
                    {Boolean(staffData?.length) ? <>
                        {staffData.map((staff: any, i: number) => {
                            return <Fragment key={i}>
                                <div className={`item-details ${selectedItem.staff?.id == staff.id ? "active" : ''}`} onClick={() => onInputChange("staff", staff)}>{staff.firstName} {staff.lastName}</div>
                            </Fragment>
                        })}
                    </> : <>
                        <div className='unavailable-data'> {languageData["Staff Unavailable"] ? languageData["Staff Unavailable"] : "Staff Unavailable"}</div>
                    </>}
                </Box>
            </ClickAwayListener>
        </div>
    }

    const renderSlotsList = () => {
        if (!selectedItem.date && !selectedItem?.staff?.id) {
            return <div className='unavailable-data'>
                {languageData["Please select date & staff to view available slots"] ? languageData["Please select date & staff to view available slots"] : "Please select date & staff to view available slots"}
            </div>
        }
        if (!selectedItem.date) {
            return <div className='unavailable-data'>
                {languageData["Please select date to view available slots"] ? languageData["Please select date to view available slots"] : "Please select date to view available slots"}
            </div>
        }
        if (!selectedItem?.staff?.id) {
            return <div className='unavailable-data'>
                {languageData["Please select expert to view available slots"] ? languageData["Please select expert to view available slots"] : "Please select expert to view available slots"}
            </div>
        }
        if (availableSlots.length == 0) {
            return <div className='unavailable-data'>
                {languageData["Slots are unavailable for this date & staff"] ? languageData["Slots are unavailable for this date & staff"] : "Slots are unavailable for this date & staff"}
            </div>
        }

        let availableSlotsCopy = [...availableSlots];
        availableSlotsCopy.pop();
        const bookedTimePoints = new Set();
        appointmentItems.forEach((serviceItem) => {
            if (serviceItem.staff && serviceItem.staff.id == selectedItem.staff.id && serviceItem.slot) {
                const startTimeInMins: any = timeToMins(serviceItem.slot);
                const durationInMins: any = getServiceDuration(serviceItem.duration, serviceItem.durationType);
                for (let i = 0; i < durationInMins; i += APPOINTMENT_SLOT_GAP_IN_MINS) {
                    bookedTimePoints.add(startTimeInMins + i);
                }
            }
        });

        return (
            <>
                <div className="slot-time-outer">
                    {availableSlotsCopy.map((storeSlot, i) => {
                        const currentSlotInMins = timeToMins(storeSlot.slot);
                        const serviceDuration = selectedItem.item.expertAppointments.reduce((duration: any, service: any) => duration + service.duration, 0)
                        const requiredSlotsCount = Math.ceil(serviceDuration / APPOINTMENT_SLOT_GAP_IN_MINS);
                        const isSelected = bookedTimePoints.has(currentSlotInMins);
                        let overlap = false;
                        if (!isSelected) {
                            for (let j = APPOINTMENT_SLOT_GAP_IN_MINS; j < serviceDuration; j += APPOINTMENT_SLOT_GAP_IN_MINS) {
                                if (bookedTimePoints.has(currentSlotInMins + j)) {
                                    overlap = true;
                                    break;
                                }
                            }
                        }

                        let hasTime = true;
                        if (requiredSlotsCount > 1) {
                            if (i + requiredSlotsCount > availableSlotsCopy.length) {
                                hasTime = false;
                            } else {
                                for (let k = 1; k < requiredSlotsCount; k++) {
                                    if (!availableSlotsCopy[i + k]?.isAvailable) {
                                        hasTime = false;
                                        break;
                                    }
                                }
                            }
                        }

                        const canBeSelected = storeSlot.isAvailable && !isSelected && !overlap && hasTime;

                        let slotText = formatTimeTo12Hr(storeSlot.slot);
                        if (!storeSlot.isAvailable) {
                            slotText = "Booked";
                        } else if (isSelected) {
                            slotText = "Selected";
                        }

                        return (
                            <div key={storeSlot.slot} onClick={() => canBeSelected && (setSelectedItem({ ...selectedItem, slot: storeSlot.slot }))}
                                className={`${canBeSelected ? '' : "unavailable"} ${selectedItem.slot === storeSlot.slot ? 'slot-wrap active' : "slot-wrap"}`} >
                                {slotText}
                            </div>
                        );
                    })}
                </div>
            </>
        );
    }

    return (
        <div className='services-cart-modal-wrap backdrop-modal-wrapper'
            onClick={onOutsideClick}
            style={{
                height: 'calc(100vh - calc(100vh - 100%))',
                overflow: 'unset',
                maxHeight: 'calc(100vh - calc(100vh - 100%))',
                backgroundColor: '#131212b3'
            }}>
            <div className='services-cart-modal-details appointment-service-form backdrop-modal-content' ref={modalRef}>
                <div className="heading"> {languageData["Reschedule Appointment"] ? languageData["Reschedule Appointment"] : "Reschedule Appointment"}</div>
                <div className='heading'>
                    {item.item.invoiceId != "" && <span>{item.item.invoiceId}</span>}
                    <div>
                        <span className="right-align order-type color">
                            {formatToDateFormat(item.item.appointmentDay, configData.dateFormat)} {formatTimeTo12Hr(item.item.appointmentTime)}
                        </span>
                    </div>
                </div>
                <div className="modal-close" onClick={onClose}>
                    <IconFrame width={20} height={20}><CloseIcon /></IconFrame>
                </div>
                <div className='services-list-wrap'>
                    <div className="input-wrap-with-label date-picker-wrap cardouter">
                        <DatePicker
                            excludeDates={getDisabledDates(configData)}
                            selected={selectedItem.date ? new Date(selectedItem.date) : null}
                            onChange={(date) => onDateChange(date)}
                            customInput={<DatePickerInput from={"Appointment Date"} />}
                            dateFormat="d MMMM yyyy"
                            minDate={new Date()}
                        />
                    </div>
                    <div className='cardouter staff-list' >
                        <div className={`label ${error.id == 'staff' ? "error" : ""}`} onClick={(e) => setAnchorEl(e.currentTarget)}>
                            {languageData["Expert"] ? languageData["Expert"] : "Expert"}: {selectedItem.staff ? ` ${selectedItem?.staff?.firstName} ${selectedItem?.staff?.lastName}` : <div className='guided-label'>Click to select expert</div>}
                        </div>
                        {/* {Boolean(anchorEl) && renderStaffList()} */}
                    </div>

                    <div className='cardouter slot-list'>
                        <div className={`label ${error.id == 'slot' ? "error" : ""}`}>{languageData["Slot"] ? languageData["Slot"] : "Slot"}: {formatTimeTo12Hr(selectedItem.slot)}</div>
                        {renderSlotsList()}
                    </div>
                </div>
                {Boolean(error.text) && <div className='error'>{error.text}</div>}
                <div className="btn-wrap">
                    <div className="primary-btn" onClick={onClose}>{languageData["Cancel"] ? languageData["Cancel"] : "Cancel"}</div>
                    <div className="primary-btn" onClick={onReschedule}>{languageData["Confirm"] ? languageData["Confirm"] : "Confirm"}</div>
                </div>
            </div>
            <ConfirmationModal {...dateChangeConfirmationModal} />
        </div>
    )
}

export default memo(BookedSlotRescheduleModal)